import React from 'react'

export default function LocationIcon() {
   return (
      <svg
         width="18"
         height="21"
         viewBox="0 0 18 21"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
      >
         <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.78125 8.5243C0.78125 3.92443 4.62513 0.206543 9.2747 0.206543C13.9374 0.206543 17.7812 3.92443 17.7812 8.5243C17.7812 10.8422 16.9383 12.9942 15.5507 14.8181C14.0201 16.8301 12.1334 18.583 10.0098 19.959C9.52376 20.277 9.08512 20.301 8.5517 19.959C6.41599 18.583 4.52934 16.8301 3.01175 14.8181C1.62323 12.9942 0.78125 10.8422 0.78125 8.5243ZM6.47548 8.78329C6.47548 10.3242 7.73291 11.5362 9.2747 11.5362C10.8175 11.5362 12.087 10.3242 12.087 8.78329C12.087 7.25434 10.8175 5.98338 9.2747 5.98338C7.73291 5.98338 6.47548 7.25434 6.47548 8.78329Z"
            fill="#F1ECDC"
         />
      </svg>
   )
}
